import { render, staticRenderFns } from "./FollowUpConsultatin.vue?vue&type=template&id=510bab0d"
import script from "./FollowUpConsultatin.vue?vue&type=script&lang=js"
export * from "./FollowUpConsultatin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports